import React from 'react';
import {Outlet} from "react-router-dom";
import {Header, MyTargetAd} from "../shared/ui";
import './styles/styles.css';

export const App = () => {
    return (
        <div>
            <Header/>
            <div className="container">
                <Outlet/>
            </div>
            <MyTargetAd/>
            <footer/>
        </div>
    );
};